import { render, staticRenderFns } from "./myCreativity.vue?vue&type=template&id=50aa4484&scoped=true"
import script from "./myCreativity.vue?vue&type=script&lang=js"
export * from "./myCreativity.vue?vue&type=script&lang=js"
import style0 from "./myCreativity.vue?vue&type=style&index=0&id=50aa4484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aa4484",
  null
  
)

export default component.exports